import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=9d8c469e&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"
import style0 from "./Language.vue?vue&type=style&index=0&id=9d8c469e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8c469e",
  null
  
)

export default component.exports
import {QPage,QList,QItem,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign({QPage,QList,QItem,QItemSection,QIcon}, component.options.components || {})
